<template>
  <div class="footer">
    <div class="content-block">
      <!-- NAVIGATION FOR RESERVATION PROCESS -->
      <div class="block is-flex">
        <div
          class="col-2"
          v-if="!this.$store.state.eventSequence"
        >
          <a
            v-if="this.$route.name == 'bestaetigungview'"
            @click="reset_Fn('/')"
            class="button control has-icons-right is-outlined is-primary"
          >{{ $t("general.button.goToHomepage") }}</a>
          <a
            v-else
            class="button control has-icons-right is-outlined is-primary"
            @click="goToPrevPath()"
          >{{ $t("general.button.back") }}<i class="arrow left" /></a>
        </div>
        <div class="col-2">
          <a
            v-if="this.$route.name == 'editview'"
            @click="saveReservationEdit()"
            class="button control has-icons-right is-primary"
          >{{ $t("slideNavigation.saveReservation") }}</a>
          <a
            v-else-if="this.$route.name == 'bestaetigungview'"
            :href="$store.state.confirmation_pdf_url"
            class="button control has-icons-right is-primary"
            target="_blank"
            download
          >{{ $t("general.button.loadAsPDF") }}</a>
          <a
            v-else-if="this.$route.name == 'bezahlview'"
            @click="reset_Fn('bestaetigung')"
            class="button control has-icons-right is-primary"
          >{{ $t("slideNavigation.backToConfirmation") }}</a>

          <a
            v-else
            class="button control has-icons-right is-primary"
            @click="nextStep()"
          >
            <template v-if="this.$route.name == 'anzahlview'">{{ $t("slideNavigation.payOnlineNow") }}</template>
            <template v-else-if="this.$route.name == 'datenview'">{{ $t("general.button.reserveNow") }}</template>
            <template v-else>{{ $t("general.button.continue") }}<i class="arrow right" /></template>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {liveURL} from '../../api-config';
import axios from 'axios'

export default {
  name: 'SlideNavigation',
  props: {
    prevRoute: {
      type: String,
      default: ''
    },
    nextRoute: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      res_link: '',
      postponed: 0
    }
  },
  watch: {
    postponed: () => {
      console.log('postponed', this.postponed);
    }
  },
  mounted() {
    if (this.$route.name === 'bestaetigungview') {
      this.fetch_GET_Reservation_Fn()
    }
  },
  methods: {
    validEmail: function (email) {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    goToPrevPath() {
      if (this.$route.name === 'editview') {
        this.reset_Fn(this.nextRoute);
      } else {
        this.$router.back();
      }
    },

    addProductsToData(eventDateId, slotId, anzahlview) {
      if (anzahlview) {
        let data = [];
        this.$store.state.fetch_GET_Tickets.filter(v => v.quantity !== 0).forEach(function (v) {
          data.push({
            eventDate: {id: eventDateId + ''},
            slot: {id: slotId + ''},
            product: {id: v.id},
            quantity: v.quantity
          });
        });
        return data;
      } else {
        return [{
          eventDate: {id: eventDateId + ''},
          slot: {id: slotId + ''},
          quantity: this.$store.state.ticket_reservation_amount
        }];
      }
    },

    prepareReservationData(anzahlview) {
      const data = {
        reservationFeeMandatory: this.$store.state.reservationType !== 3,
        reservationProducts: []
      }

      if (this.$store.state.reservationNr) {
        data.reservationNr = this.$store.state.reservationNr;
      }

      const datesAndSlots = [
        [this.$store.state.talfahrt_EventDate_ID, this.$store.state.talfahrt_Slot_ID],
        [this.$store.state.bergfahrt_EventDate_ID, this.$store.state.bergfahrt_Slot_ID],
        [this.$store.state.subset_EventDate_ID, this.$store.state.subset_Slot_ID]
      ];

      for (const i of datesAndSlots) {
        if (i[0] && i[1]) {
          data.reservationProducts = [
            ...data.reservationProducts,
            ...this.addProductsToData(i[0], i[1], anzahlview)
          ];
        }
      }

      if (this.$store.state.fetch_GET_additionalProducts.length > 0 && data.reservationProducts[0]) {
        data.reservationProducts[0].additionalProducts = this.$store.state.fetch_GET_additionalProducts
          .filter(p => p.quantity !== 0)
          .map((p) => ({
            product: {id: p.id},
            quantity: p.quantity,
            optional: false
          }));
      }

      console.log(data);

      return data;
    },

    updateReservation() {
      const anzahlview = this.$route.name === 'anzahlview';

      const conditions = {
        1: this.$store.state.bergfahrt_Slot_ID && this.$store.state.talfahrt_Slot_ID,
        2: this.$store.state.bergfahrt_Slot_ID && !this.$store.state.talfahrt_Slot_ID,
        3: !this.$store.state.bergfahrt_Slot_ID && this.$store.state.talfahrt_Slot_ID,
        4: this.$store.state.subset_Slot_ID
      }
      const condition = conditions[this.$store.state.selectedType > 3 ? 4 : this.$store.state.selectedType];
      if (condition && this.$store.state.ticket_reservation_amount > 0 && !(anzahlview && this.$store.state.unassignedTickets > 0)) {
        if (this.$store.state.selectedType === 1 && this.$store.state.bergfahrt_Slot_Time > this.$store.state.talfahrt_Slot_Time) {
          this.$store.state.customMessageModal_MessageTitle = this.$t('general.label.attention');
          this.$store.state.customMessageModal_MessageSubTitle = this.$t('fahrtView.label.descentCanNotBeBeforeAscentHint');
          this.$store.state.isModal_CustomMessageActive = true;
          return;
        }

        const data = this.prepareReservationData(anzahlview);

        if (data.reservationProducts.length > 0) {
          try {
            const url = liveURL + (this.$store.state.reservationNr
              ? "/api/eventReservation/frontend/modify"
              : "/api/eventReservation/create");
            axios.post(url, data).then((r) => {
              if (r.data && r.data.reservationNr) {
                this.$store.state.reservationNr = r.data.reservationNr;
                const routes = {
                  1: 'bezahlen',
                  2: 'tickets',
                  3: 'daten'
                }
                if (this.$store.state.reservationType === 1 || anzahlview) {
                  const prepareUrl = liveURL + `/api/eventReservation/purchase/prepare/${this.$store.state.reservationNr}`;
                  axios.get(prepareUrl, {}).then((r) => {
                    if (!r.error) {
                      this.$store.state.checkout_link = r.data.redirectUrl;
                      const route = anzahlview ? 'bezahlen' : routes[this.$store.state.reservationType];
                      this.$router.push(route);
                    } else {
                      console.error("API ERROR;", r);
                      throw new Error('error in ' + prepareUrl);
                    }
                  });
                } else {
                  this.$router.push(routes[this.$store.state.reservationType]);
                }
              } else {
                console.error("API ERROR;", r);
                throw new Error('error in ' + url);
              }
            });
          } catch (e) {
            console.error("API ERROR;", e);
            this.$router.push('fehler')
          }
        } else {
          //TODO: display proper error message
          console.error('no products');
        }
      } else {
        this.$store.state.isModal_InputActive = true;
      }
    },

    completeReservation() {
      if (this.$store.state.customer.firstName
        && this.$store.state.customer.lastName
        && this.$store.state.customer.telephone
        && this.$store.state.customer.email
        && this.validEmail(this.$store.state.customer.email)
        && this.$store.state.customer.email === this.$store.state.customer.emailRepeat) {
        const data = {
          reservationNr: this.$store.state.reservationNr,
          customer: this.$store.state.customer,
          comment: this.$store.state.comment
        }
        try {
          const url = liveURL + "/api/eventReservation/complete";
          axios.put(url, data).then((r) => {
            if (r.data && r.data.reservationNr) {
              this.$store.state.confirmation_pdf_url = liveURL + "/api/eventReservation/frontend/confirmation/" + r.data.reservationNr;
              this.$router.push('bestaetigung');
            }
          });
        } catch (e) {
          console.error("API ERROR;", e);
          this.$router.push('fehler')
        }
      } else {
        this.$store.state.isModal_InputActive = true;
      }
    },

    nextStep() {
      if (this.$route.name === 'datenview') {
        this.completeReservation();
      } else this.updateReservation();
    },
    saveReservationEdit() {
      this.$store.state.isLoading = true;
      const sequences = {
        1: 'bergfahrt',
        3: 'talfahrt',
        4: 'subset'
      }
      for (const seqId in this.$store.state.edit_slots) {
        const slot = this.$store.state.edit_slots[seqId];
        if (slot.id === this.$store.state[`${sequences[seqId]}_Slot_ID`]) continue;
        axios.post(liveURL + '/api/eventReservation/frontend/postponeProductsBySlot', {
          reservationNr: this.$store.state.reservation_ID,
          slotFrom: {
            id: slot.id
          },
          slotTo: {
            id: this.$store.state[`${sequences[seqId]}_Slot_ID`]
          }
        }).catch((error) => {
          this.$store.state.isLoading = false;
          this.$store.state.edit_success = true;
          this.$store.state.customMessageModal_MessageTitle = this.$t('editView.error.title');
          if (error.response.data.code === "0") {
            this.$store.state.customMessageModal_MessageSubTitle = this.$t('editView.error.noMoreEdit', {resNr: this.$store.state.reservation_ID});
          } else {
            console.error(error.response);
            this.$store.state.customMessageModal_MessageSubTitle = this.$t('editView.error.serverError');
          }
          this.$store.state.isModal_CustomMessageActive = true;
        });
      }

      this.$store.state.isLoading = false;
      this.$store.state.edit_success = true;
      if (this.$store.state.edit_slots.length > 0) {
        this.$store.state.customMessageModal_MessageTitle = this.$t('editView.success.title');
        this.$store.state.customMessageModal_MessageSubTitle = this.$t('editView.success.msg', {resNr: this.$store.state.reservation_ID});
      } else {
        this.$store.state.customMessageModal_MessageTitle = this.$t('editView.cancel.title');
        this.$store.state.customMessageModal_MessageSubTitle = this.$t('editView.cancel.msg');
      }
      this.$store.state.isModal_CustomMessageActive = true;
    },
    reset_Fn(route) {
      this.$store.state.refresh = true
      this.$router.push(route)
    },
    fetch_GET_Reservation_Fn() {
      let res_ID = this.$store.state.reservation_ID

      this.res_link = liveURL + '/api/ticket/slot/getBookingConfirmationPDF/' + res_ID + '/' + (this.$t('general.settings.currentLanguage'))
    }
  }
}
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  height: auto;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.96);
  position: fixed;
  bottom: 0;
  left: 0;
  box-shadow: 0px -3px 12px rgba(3, 1, 1, 0.1);
  z-index: 110;

  .content-block {
    margin: 0;
    padding: 0;
  }

  .block {
    padding: 0;
    border: none;
    box-shadow: none;
  }

  .icon {
    font-size: 1.4em;
    margin-top: -0.25em;

    &.is-left {
      margin-left: 0.2em;
      color: #004e9f !important;
    }

    &.is-right {
      margin-right: 0.2em;
      color: #ffffff !important;
    }
  }
}

@media (max-width: 680px) {
  .footer {
    .block {
      flex-direction: column;

      .col-2 {
        padding-top: 0 !important;
      }

      .button {
        border-radius: 0px 0px 0px 0px;
      }
    }
  }
}
</style>
